import { useParams } from "react-router";
import { GetEventPageBySlug } from "@queries/GetEventPageBySlug";
import { useContent } from "@hooks/useContent";
import { Loading } from "./Loading";
import { NotFound } from "./NotFound";
import { EventPage } from "./EventPage";

export const EventPageResolver = () => {
  const { slug } = useParams();

  const [response] = useContent({
    query: GetEventPageBySlug,
    variables: { slug: slug },
  });

  if (response.fetching) {
    return <Loading />;
  }

  const [page] = response.data?.eventsEventPageCollection?.items ?? [];

  if (!response.data || !slug || !page) {
    return <NotFound />;
  }

  return <EventPage key={slug} page={page!} />;
};
